import { render, staticRenderFns } from "./CheckTransaction.vue?vue&type=template&id=2d28f476&"
import script from "./CheckTransaction.vue?vue&type=script&lang=js&"
export * from "./CheckTransaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports